import Core from '../plugin-core-system/core.class.js';


export default class CsGlobal extends Core {

  // openItemOnLoad: count from zero, negative values won't open any item at all -> is the number behind id="accordion-trigger-XXX"
  // openMultipleItems: if true, the active item won't close on trigger
  static options = {
  };

  dollarConversion() {
    if (!document.querySelector('body[data-dollar-currency-translation]')) {
      return;
    }

    const currencyTranslation = document.querySelector(('body[data-dollar-currency-translation]')).getAttribute('data-dollar-currency-translation').replace(',', '.');

    if (parseFloat(currencyTranslation) <= 0) {
      return;
    }

    const formatToThousandPoints = (number) => {
      number = number.toString();

      if (number.length <= 3) {
        return number;
      }

      const mod = number.length % 3;
      let output = mod > 0 ? number.substring(0, mod) : '';

      for (let i = 0; i < Math.floor(number.length / 3); i++) {
        if (mod === 0 && i === 0) {
          output += number.substring(mod + 3 * i, mod + 3 * i + 3);
        } else {
          // Define the thousands separator here
          output += '.' + number.substring(mod + 3 * i, mod + 3 * i + 3);
        }
      }

      return output;
    };

    const dollarElements = document.querySelectorAll('.dollar-currency-translation');

    dollarElements.forEach((element) => {
      // Convert "$ 3.113,95" to "3113.95"
      // Convert "$ 3.113,-" to "3113"
      let dollar = element.textContent
      .replace('$ ', '')
      .replace('.', '')
      .replace(',-', '')
      .replace(',', '.');

      let euro = parseFloat(dollar) * parseFloat(currencyTranslation);
      euro = Math.ceil(euro);

      const formattedEuro = formatToThousandPoints(euro);
      element.textContent = `€ ${formattedEuro},-`;
    });
  }

  checkFrameClass() {
    const selector = [
      '.frame-layout-860',
      '.frame-type-csgatewayproducts_triplist'
    ].join(',');

    const removeBgClass = 'frame--remove-bg';
    const elements = Array.from(document.querySelectorAll(selector));

    let currentGroup = [];

    function processGroup(group) {
      // Only process real chains with at least 2 directly following elements
      if (group.length < 2) {
        return;
      }

      group.forEach((element) => {
        element.classList.remove(removeBgClass);
      });

      group.forEach((element, index) => {
        const positionFromEnd = group.length - index;

        // 2nd, 4th, 6th ... element from the end
        if (positionFromEnd % 2 === 0) {
          element.classList.add(removeBgClass);
        }
      });
    }

    elements.forEach((element, index) => {
      const previousElement = elements[index - 1];

      const isDirectFollower =
        previousElement &&
        previousElement.nextElementSibling === element;

      if (!isDirectFollower) {
        processGroup(currentGroup);
        currentGroup = [];
      }

      currentGroup.push(element);
    });

    processGroup(currentGroup);
  }

  headerFixed() {
    const base = document.querySelector('.js-header');
    const threshold = 300;
    const initialDelayMs = 1000;
    const initialAnimationMs = 700;
    const initialAnimationClass = 'fixed-visible--initial';
    let triggeredScrollUp = false;
    let lastScrollTop = document.documentElement.scrollTop;

    if (!base) {
      return;
    }

    function scrollUp() {
      base.classList.remove(initialAnimationClass);

      if (window.scrollY <= threshold) {
        if (!triggeredScrollUp) {
          base.classList.remove('fixed-visible');
          triggeredScrollUp = true;
        }
      } else {
        triggeredScrollUp = false;
      }
    }

    function scrollDown() {
      base.classList.remove(initialAnimationClass);

      if (window.scrollY > threshold) {
        base.classList.add('fixed-visible');
      }
    }

    // Nur beim initialen Laden oberhalb des Thresholds: erst kurz voll zeigen, dann sanft einklappen.
    if (window.scrollY > threshold) {
      base.classList.add(initialAnimationClass);

      window.setTimeout(() => {
        base.classList.add('fixed-visible');

        window.setTimeout(() => {
          base.classList.remove(initialAnimationClass);
        }, initialAnimationMs);
      }, initialDelayMs);
    } else {
      base.classList.remove('fixed-visible');
    }

    window.addEventListener('scroll', () => {
      const currentScrollTop = document.documentElement.scrollTop;

      if (currentScrollTop > lastScrollTop) {
        scrollDown();
      } else if (currentScrollTop < lastScrollTop) {
        scrollUp();
      }
      lastScrollTop = currentScrollTop;
    }, { passive: true });
  }



  init() {
    this.dollarConversion();

    this.checkFrameClass();
    this.headerFixed();
  }
}
